import { getPublicActivityPath, getPublicEventCodeFromReference } from '@fitro/event-contract'
import type { Course } from '@fitro/courses'
export function getPublicCoursePath(course: Pick<Course, 'name' | 'publicCode' | 'id'>): string {
    const path = getPublicActivityPath('course', { className: course.name, publicCode: course.publicCode })
    if (!path) throw new Error('Invalid public course code')
    return path
}
export function getPublicCourseCode(reference: string): string {
    return getPublicEventCodeFromReference(reference) ?? reference
}
